const Genesis = require("../Genesis.js")
import { PreLoadHelper } from '../Helpers/helpers';
import 'jquery-ui';
import ko from 'knockout';
let AutoComplete = require("./assetEdit.js");
import flatpickr from "flatpickr";
import { BlockPageHelper } from '../Helpers/helpers';
import confirmDatePlugIn from "flatpickr/dist/plugins/confirmDate/confirmDate";
import { CategoryPathComponent } from '../Shared/CategoryPath/CategoryPathComponent';
import { Modal } from 'bootstrap';
import { string32 } from 'pdfjs-dist/types/src/shared/util';
import { ISiteMobileAssetSearchAssetPage } from './ISiteMobileAssetSearchAssetPage';
import { QRCodeScanner } from "../Components/QRCodeScanner";

export class ISiteMobileAssetEditAssetPage {

    private category: CategoryPathComponent = new CategoryPathComponent({
        ModalId: 'classificationModal',
        Url: Genesis.url('/Asset/_CategoryPath'),
        PathId: 'categoryPath',
        SelectButtonId: 'selectCategoryButton',
        IsReadOnly: false,
        PreventParentSelection: true,
        AllowMultiSelect: false,
        IsRequired: true,
        FormId: "AssetForm"
    });
    private readonly idConfirmModal = document.getElementById("confirmPopulateQRCode-modal");
    private confirmModal: Modal | null = null;
    private readonly idConfirmYes = $("#idConfirmYes");
    private qrCodeScanner: QRCodeScanner | null = new QRCodeScanner;

    constructor() {
        if (this.idConfirmModal !== null) {
            this.confirmModal = new Modal(this.idConfirmModal, { backdrop: 'static', keyboard: false });
        }
    }
    public Init() {


        AutoComplete();

        $("#classificationModal").detach().appendTo("#modalContainerPlaceholder");

        let $elements = $("[id^='classificationModal']");
        while ($elements.length >= 2) {
            $elements.first().remove();
            $elements = $("[id^='classificationModal']");
        }

        try {
            ko.applyBindings(this.category);
        }
        catch (e) {
            // Bindings already created, no need to do anything
        }

        $('#AssetForm').off('submit');
        $("#AssetForm").submit((e: any) => {
            BlockPageHelper.block();
            const form = e.target;
            if (form !== null) {
                this.validateAutoComplete(form, "propertySearch", "RelatedProperty");
                this.validateDropDown(form, "AssetTypeID");
                this.validateDropDown(form, "StatusID");
                this.category.validateCategorySelected();
                if (!this.processWarrantyExpiryDate(false)) {
                    return false;
                }
                if (!form.checkValidity()) {
                    form.classList.add('was-validated');
                    BlockPageHelper.unblock();
                    return false;
                }
            }
        });

        flatpickr("#InstallationDate", this.getDateConfig("#InstallationDate"));
        flatpickr("#PurchaseDate", this.getDateConfig("#PurchaseDate"));
        flatpickr("#DateConditionAssessed", this.getDateConfig("#DateConditionAssessed"));
        flatpickr("#WarrantyStartDate", this.getDateConfig("#WarrantyStartDate"));

        var scannedCode = localStorage.getItem('ScannedCode');
        var that = this;
        if (scannedCode !== null) {
            this.idConfirmYes.click(function () {
                if (scannedCode != null) {
                    $("#AssetTag").val(scannedCode);
                    localStorage.removeItem('ScannedCode');
                }
                that.confirmModal?.hide();
            });

            this.confirmModal?.show();
        }
        $("#idScanAssetTag").click(async function () {
            await that.qrCodeScanner?.startScanning();
            const scannedCode = await that.qrCodeScanner?.scanBarcodeOrQRCode();
            if (scannedCode != null)
                $("#AssetTag").val(scannedCode);
            await that.qrCodeScanner?.stopScanning();
        });

        $("#idConfirmNo").click(async function () {
            that.confirmModal?.hide();
        });

        $('#modal-Scanner .modal-header a[data-bs-dismiss="modal"]').click(function () {
            that.qrCodeScanner?.stopScanning();
        });

        $("#PurchaseDate").on("change", (e: any) => {
            this.processWarrantyExpiryDate(true);
        });

        $("#WarrantyPeriod").on("change", (e: any) => {
            this.processWarrantyExpiryDate(true);
        });

        $("#InstallationDate").on("change", (e: any) => {
            this.processWarrantyExpiryDate(true);
        });

        $("#WarrantyStartDate").on("change", (e: any) => {
            this.processWarrantyExpiryDate(true);
        });
    }

    private processWarrantyExpiryDate(showConfirm: boolean): boolean {
        const warrantyPeriod = parseInt($("#WarrantyPeriod").val() as string, 10);
        const purchaseDate = $("#PurchaseDate").val() as string;
        const installationDate = $("#InstallationDate").val() as string;
        const warrantyStartDate = $("#WarrantyStartDate").val() as string;
        let warrantyValidationMsg: string = "";

        if (isNaN(warrantyPeriod)) {
            warrantyValidationMsg = "Warranty Period Required.";
        }
        else if (installationDate && !warrantyStartDate) {
            warrantyValidationMsg = "As you added installation Date. The Warranty Start Date is required.";
        }
        else if (!installationDate && warrantyStartDate) {
            warrantyValidationMsg = "As you added Warranty Start Date. The installation Date is required.";
        }

        if (showConfirm && warrantyValidationMsg !== "") {
            return false;
        }

        const baseDateString = installationDate && installationDate.trim() !== ""
            ? installationDate
            : purchaseDate;

        const [day, month, year] = baseDateString.split('/').map(Number);

        const baseDate = new Date(year, month - 1, day);
        let newWarranty = new Date(baseDate);

        newWarranty.setMonth(newWarranty.getMonth() + warrantyPeriod);

        if (!isNaN(newWarranty.getTime())) {
            const formattedDate = newWarranty.toLocaleDateString('en-GB');
            $("#WarrantyExpiryDate").val(formattedDate);
        }
        return true;
    }



    private validateAutoComplete(form: any, searchField: string, idField: string) {
        const search = form.elements[searchField];
        const id = form.elements[idField];
        if (search !== null) {
            search.setCustomValidity('');
            if (id.value === '0') {
                search.setCustomValidity('invalid');
                search.classList.add("invalid");
            }
        }
    }

    private parseDatedmy(dateString: string): string | null {
        const normalizedDateString = dateString.replace(/[-.]/g, '/').replace(/,/g, '');
        const timestamp = Date.parse(normalizedDateString);

        if (!isNaN(timestamp)) {
            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return null;
    }


    private validateMonth(form: any, idField: string) {
        const id = form.elements[idField];
        if (id.value != 0 && id.value > 11) {
            id.setCustomValidity('invalid');
            id.classList.add("invalid");
        }
    }

    private validateDropDown(form: any, idField: string) {
        const id = form.elements[idField];
        if (id != undefined && id.value === '0') {
            id.setCustomValidity('invalid');
            id.classList.add("invalid");
        }
        if (id != undefined && id.value !== '0') {
            id.setCustomValidity('');
            id.classList.remove("invalid");
        }
    }

    private getDateConfig(selector: string): any {
        let existingDate: string | null = $(selector).val() as string | null;
        return {
            dateFormat: "d/m/Y",
            enableTime: true,
            time_24hr: true,
            defaultDate: existingDate ? this.parseDatedmy(existingDate) : existingDate,
            plugins: [confirmDatePlugIn({
                confirmIcon: "<i class='fa fa-check'></i>",
                confirmText: "OK ",
                showAlways: true,
                theme: "dark"
            })]
        };
    }
};